import React, { useEffect, useState } from "react";
import Sidebar from "../../../layout/Sidebar";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import AdminDataTable from "../../../components/common/AdminDataTable";
import { renewMembersColumns } from "../../../tables/renewMembersColumns";
import { can } from "../../../utils/can";

export default function RenewMemberList() {
  const PAGE_SIZE = 10;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);

  // filters
  const [name, setName] = useState("");
  const [membershipPlan, setMembershipPlan] = useState("");
  const [membershipStatus, setMembershipStatus] = useState("");

  const token = localStorage.getItem("adminToken");
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";

  /* ---------------- FETCH DATA ---------------- */
  const fetchMembers = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `${API_URL}/api/admin/attribute/renew-member-list?page=${page}&limit=${pageSize}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            name,
            membershipPlan,
            membershipStatus, // Active / Expired
          }),
        }
      );

      const result = await res.json();

      if (result.success) {
        setMembers(result.data);
        setTotalPages(result.totalPages || 1);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers();
  }, [page, pageSize]);

  /* ---------------- ACTIONS ---------------- */
  const handleRenew = async (row) => {
    if(can("renew_member", "edit") === false) {
      alert("You don't have permission to renew memberships.");
      return;
    }
    
    const confirmed = window.confirm(
      "Are you sure you want to renew this membership?"
    );

    if (!confirmed) return;

  try {
    const userId = row._id;
    const planId = row.userPlan.plan_id;
    const historyId = row._id;

    const response = await fetch(`${API_URL}/api/admin/attribute/renew-member`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        userId,
        planId,
        historyId
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Renew failed");
    }

    console.log("Renew Success:", data);
    alert(data.message);
    fetchMembers(); // Refresh list after renewal

  } catch (error) {
    console.error("Renew Error:", error);
    alert(error.message);
  }
};

  const handleCancelled = async (row, status) => {
    if(can("renew_member", "delete") === false) {
      alert("You don't have permission to cancel memberships.");
      return;
    }

  try {

     const confirmed = window.confirm(
      "Are you sure you want to cancel this membership?"
    );

    if (!confirmed) return;
   
    
    const userId = row._id;
    const planId = row.userPlan.plan_id;
    const historyId = row._id;

    const response = await fetch(`${API_URL}/api/admin/attribute/cancelled-membership`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        userId,
        planId,
        historyId,
        status
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Cancel failed");
    }

    console.log("Cancel Success:", data);
    alert(data.message);
    fetchMembers(); // Refresh list after cancellation

  } catch (error) {
    console.error("Cancel Error:", error);
    alert(error.message);
  }
};

  const columns = renewMembersColumns({
    handleRenew,
    handleCancelled,
    PAGE_SIZE,
    ageCalculate: (dob) =>
      Math.floor((Date.now() - new Date(dob)) / (365.25 * 24 * 60 * 60 * 1000)),
  });

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="Renew Members List" />

        <div className="right_col" role="main">
         

          <div className="x_panel">
            <div className="x_title">
              <h2>List</h2>
              <div className="clearfix" />
            </div>

            <div className="x_content">
              {/* FILTER */}
              <div className="filtercont">
                <div className="row">
                  <div className="col-sm-4">
                    <label>Filter By Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-2">
                    <label>Membership Plan</label>
                    <select
                      className="form-control"
                      value={membershipPlan}
                      onChange={(e) => setMembershipPlan(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value={"6913323a5be8a54eb6b4ab7a"}>Basic Plan</option>
                      <option value={"691332c75be8a54eb6b4ab88"}>Gold Plan</option>
                      <option value={"691332df5be8a54eb6b4ab8c"}>Premium Plan</option>
                      <option value={"691adb901359ae4b3e061973"}>VIP Shaadi</option>
                    </select>
                  </div>

                  <div className="col-sm-2">
                    <label>Membership Status</label>
                    <select
                      className="form-control"
                      value={membershipStatus}
                      onChange={(e) => setMembershipStatus(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value="Active">Active</option>
                      <option value="Expired">Expired</option>
                    </select>
                  </div>

                  <div className="col-sm-2">
                    <label>&nbsp;</label>
                    <button
                      className="btn btn-default submit sitebtn w-100"
                      onClick={() => {
                        setPage(1);
                        fetchMembers();
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>

              {/* TABLE */}
              <AdminDataTable
                columns={columns}
                data={members}
                page={page}
                pageSize={pageSize}
                totalPages={totalPages}
                loading={loading}
                onPageChange={setPage}
                onPageSizeChange={(size) => {
                  setPageSize(size);
                  setPage(1);
                }}
              />
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
